import React, { useState } from 'react';
import ImageUploader from '../imageUploader';
import { useDispatch, useSelector } from 'react-redux';
import { GET_PRESIGNED_IMAGE_URLS } from '../../redux/api/constants';
import { doCreate, s3upload } from '../../redux/api/actions';

const EditCategoryModal = ({ show, handleClose, category, handleSave }) => {
    const [title, setTitle] = useState(category.title);

    const [imageFiles, setImageFiles] = useState([])
    const accessToken = useSelector(state => state.Auth.accessToken);
    const dispatch = useDispatch();
    const presignedImageUrls = useSelector(state => state.API.presignedImageUrls);


    const handleSubmit = () => {
        // if they save, then we should upload the image
        if (presignedImageUrls && presignedImageUrls.length > 0) {
            dispatch(s3upload(imageFiles, presignedImageUrls));
        }
        const cleanedUrls = presignedImageUrls.map(u => new URL(u).origin + new URL(u).pathname).join(',');

        handleSave({ ...category, title: title, photo_file_name: cleanedUrls });
        handleClose();
    };

    const handleImageUpload = (images) => {
        // Get the presigned URLs first
        // Then upload the images to the presigned URLs
        const fileNames = Array.from(images).map((f) => f.name);
        dispatch(doCreate(
            GET_PRESIGNED_IMAGE_URLS,
            "images/presigned-urls",
            accessToken,
            { "images": fileNames }
        ))
        setImageFiles(images);

    }

    return (
        <div className={`modal fade custom-modal ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none' }} tabIndex="-1">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Edit Category</h5>
                        <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label htmlFor="formCategoryTitle" className="form-label">Category Title</label>
                            <input
                                type="text"
                                className="form-control"
                                id="formCategoryTitle"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            />
                            <ImageUploader imageUrls={category.photo_file_name ? [category.photo_file_name] : []} imageUploadFunc={handleImageUpload} />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={handleClose}>Close</button>
                        <button type="button" className="btn btn-primary" onClick={handleSubmit}>Save Changes</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditCategoryModal;
